import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Stack,
} from '@mui/material'
import { useState } from 'react'
import { CompanyStatus } from '../../CompanyStatus'
import type { CompanyStatus as CompanyStatusEnum } from '@/api/models/company'

const buttonStyle = {
  boxShadow: 'none',
  borderRadius: '4px',
  textTransform: 'none',
  padding: '10px 12px',
  height: '30px',
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '1.3',
  '&:hover': { boxShadow: 'none' },
}

const formControlLabelStyle = {
  //margin: '0px',
}

interface FilterProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFilterRequest?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClose?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setMode?: any
}
export const StatusFilter = ({
  handleClose,
  setFilterRequest,
  setMode,
}: FilterProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [statuses, setStatuses] = useState<any>({
    DRAFT: false,
    CONFIRMED: false,
    DELETED: false,
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStatuses({ ...statuses, [event.target.name]: event.target.checked })
  }

  const handleConfirmFilter = () => {
    const resultArray = Object.keys(statuses).filter(
      (key) => statuses[key] === true
    )
    console.log(resultArray)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFilterRequest((prev: any) => ({ ...prev, status: resultArray }))
    // setFilterRequest((prev: any) => ({ ...prev, status: { in: resultArray } }))
    setMode(true)
    handleClose(true)
  }

  const handleResetFilter = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFilterRequest((prev: any) => {
      const state = { ...prev }
      delete state.status
      return state
    })
    setMode(false)
    handleClose(false)
  }

  return (
    <Stack sx={{ padding: '8px 12px', gap: '8px' }}>
      <FormControl
        component="fieldset"
        variant="standard"
        sx={{ margin: '-7px 0px -5px 0px' }}
      >
        <FormGroup>
          {Object.keys(statuses).map((key) => (
            <FormControlLabel
              key={key}
              label={<CompanyStatus status={key as CompanyStatusEnum} />}
              control={
                <Checkbox
                  checked={statuses[key]}
                  onChange={handleChange}
                  name={key}
                />
              }
              sx={formControlLabelStyle}
            />
          ))}
        </FormGroup>
      </FormControl>

      <Divider sx={{ margin: '0px -12px' }} />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
        <Button
          sx={{
            ...buttonStyle,
            backgroundColor: '#FFFFFF',
            color: '#009FDA',
            border: '2px solid #009FDA',
            '&:hover': { backgroundColor: '#F0F7FF' },
          }}
          onClick={handleResetFilter}
        >
          Сброс
        </Button>
        <Button
          sx={{
            ...buttonStyle,
            backgroundColor: '#009FDA',
            color: '#FFFFFF',
            '&:hover': { backgroundColor: '#007DB8' },
          }}
          onClick={handleConfirmFilter}
        >
          Подтвердить
        </Button>
      </Box>
    </Stack>
  )
}
